import { useQuery } from '@tanstack/react-query'

import { PermissionSet, useBusinessContext, useFeature, usePermission } from '@root/context'
import { fetchElsterCertificateStatus } from '../integrations/elster'

export const useElsterCertificateStatus = () => {
  const { slug } = useBusinessContext()
  const hasPermission = usePermission(PermissionSet.REPORTING_ADMIN)
  const { enabled: vatExternalReporting } = useFeature('vat_external_reporting')
  const { enabled: elsterEnabled } = useFeature('elster')

  return useQuery({
    queryKey: [slug, 'elster_certificate_status'],
    queryFn: () => fetchElsterCertificateStatus({ slug }),
    ...{
      staleTime: 15000,
      enabled: hasPermission && vatExternalReporting && elsterEnabled
    }
  })
}
